module.exports = __webpack_public_path__ + "img/news18_5.28b2da5e.jpg";